import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import Amplify from "@aws-amplify/core";
import config from "./aws-exports";

import App from "./App";
import store from "./stores";
import theme from "./theme";

Amplify.configure(config);

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
